import { SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_LG } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledAudicodeWrapper = styled.div`
	.audicode-label-group {
		gap: 4px;
		${breakPoints({
			'375': `
			gap: 8px
		`,
		})}
	}

	.audicode-label {
		justify-content: center;
		width: 32px;
		min-height: 32px;
	}
`;

export const StyledMyAudiWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	background-color: rgb(242, 242, 242);
	padding: ${SYS_SPACE_RELATIVE_LG};

	${breakPoints({
		'768': `
			grid-template-columns: auto 1fr;
		`,
	})}
	ul {
		gap: 12px;
		display: grid;
		list-style-type: none;
		padding-left: 0;
	}

	li {
		display: flex;
		align-items: flex-start;
	}

	li::before {
		content: '>';
		font-size: 8px;
		line-height: 20px;
		margin-right: ${SYS_SPACE_FIXED_150};
	}
`;

export const StyledMainContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const StyledItemsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
`;
